import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var ArrowUpIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 14 7" }),
    React.createElement("path", { d: "M7 .594a1 1 0 00-.625.219L.594 5.438 1.844 7 7 2.874l5.156 4.12 1.25-1.562L7.625.807A1 1 0 007 .594z" }))); };

export { ArrowUpIcon as default };
